import { ResolveFn, Router } from '@angular/router';
import { EsupervisorService } from '../core/services/esupervisor.service';
import { inject } from '@angular/core';
import { catchError, EMPTY } from 'rxjs';

export const esupervisorResolver: ResolveFn<any> = (route, state) => {
  const service = inject(EsupervisorService);
  const router = inject(Router);
  
  const username = route.paramMap.get('username');
  return service.geteSupervisorDetailByUsername(username!).pipe(
    catchError((error) => {
      console.error('Resolver error:', error);

      // Redirect to 404 page
      router.navigate(['/not-found']);

      return EMPTY;
    })
  );
};
